module.exports = __webpack_public_path__ + "img/1121880505.6dd4662c.png";